import { render, staticRenderFns } from "./sessionsTable.vue?vue&type=template&id=192efbc3"
import script from "./sessionsTable.vue?vue&type=script&lang=js"
export * from "./sessionsTable.vue?vue&type=script&lang=js"
import style0 from "./sessionsTable.vue?vue&type=style&index=0&id=192efbc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports